import { ROUTES } from '../../routes/consts';
import { getDynamicSetting, getAppUrl } from '../../utils/dynamicSettings';

/*********************
 * URL configurations
 *********************/
export const V2_REDIRECT_URI_FOR_EXTERNAL_CLIENTS = `${getAppUrl()}${
  ROUTES.SUCCESS_SIGNIN_EXTERNAL_CLIENT
}`;

// Getter, not a module-level const: config arrives from an async backend fetch,
// so a value snapshotted at module-eval would freeze on the provisional fallback.
export const getGoogleClientId = () =>
  getDynamicSetting('google_client_id_oidc');

/*********************
 * Check your email
 *********************/
export const SEND_AGAIN_MAX_ATTEMPTS = 3;
export const SEND_AGAIN_FREEZE_DURATION = 1000 * 60 * 10; // 10 minutes
export const INITIAL_SEND_AGAIN_CLICK_VALUE = { count: 0, timestamp: 0 };
